import React, { useEffect, useState, useMemo, useRef } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import "../Style/VendorFilter.css";

const DatalistInput = ({
  label,
  name,
  value,
  listId,
  options,
  onChange,
  showList,
  inputRef,
  onKeyDown,
}) => (
  <Form.Group
    as={Col}
    xs={6}
    sm={4}
    md={3}
    lg={2}
    className="filter-field"
    controlId={name}
  >
    <div className="dropdown-label">{label}</div>
    <Form.Control
      type="text"
      list={showList ? listId : undefined}
      value={value || ""}
      placeholder={label}
      autoComplete="off"
      onChange={(e) => onChange(name, e.target.value)}
      onKeyDown={onKeyDown}
      onFocus={() => showList !== undefined && showList}
      ref={inputRef}
    />
    {showList && (
      <datalist id={listId}>
        {options.map((opt, i) => (
          <option key={i} value={opt.label} />
        ))}
      </datalist>
    )}
  </Form.Group>
);

const PaymentFilter = ({
  filters,
  vendors,
  onFilterChange,
  onFind,
  onReset,
  loading,
}) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const [showDropdown, setShowDropdown] = useState({
    vehicle_name: false,
    status: false,
  });
  const vehicleRef = useRef(null);
  const fromDateRef = useRef(null);
  const statusRef = useRef(null);
  const findBtnRef = useRef(null);
  const resetBtnRef = useRef(null);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const vehicleOptions = useMemo(
    () => vendors.map((v) => ({ id: v.id, label: v.name })),
    [vendors],
  );

  const handleVehicleChange = (name, value) => {
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
    onFilterChange("name", value);

    const vehicle = vehicleOptions.find(
      (v) => v.label.toLowerCase() === value.toLowerCase(),
    );

    if (vehicle) {
      onFilterChange("vendor_id", vehicle.id);
    } else {
      onFilterChange("vendor_id", "");
    }

    setShowDropdown({ name: value.trim().length > 0 });
  };
  const handleKeyDown = (e, nextRef, action) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (typeof action === "function") {
        action();
      }
      nextRef?.current?.focus();
    }
  };

  const statusOptions = [
    { value: "new", label: "new" },
    { value: "process", label: "process" },
    { value: "paid", label: "paid" },
  ];

  return (
    <Form className="vendor-advance-filter-form">
      <Row className="g-2 align-items-end">
        <DatalistInput
          label="Vendor"
          name="name"
          value={localFilters.name || ""}
          listId="vendorList"
          options={vehicleOptions}
          onChange={handleVehicleChange}
          showList={showDropdown.name}
          inputRef={vehicleRef}
          onKeyDown={(e) => handleKeyDown(e, fromDateRef)}
        />

        {/* {renderDatePicker("From Date", "date", localFilters.date)}
        {renderDatePicker("To Date", "to_date", localFilters.to_date)} */}

        <Form.Group as={Col} xs={6} sm={4} md={3} lg={2}>
          <div className="dropdown-label">Date</div>
          <Form.Control
            type="date"
            value={localFilters.date || ""}
            ref={fromDateRef}
            onChange={(e) => onFilterChange("date", e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, statusRef)}
          />
        </Form.Group>

        {/* To Date */}
        {/* <Form.Group as={Col} xs={6} sm={4} md={3} lg={2}>
          <div className="dropdown-label">To Date</div>
          <Form.Control
            type="date"
            value={localFilters.to_date}
            ref={toDateRef}
            onChange={(e) => handleInputChange("to_date", e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, findBtnRef)}
          />
        </Form.Group> */}
        <Form.Group as={Col} xs={6} sm={4} md={3} lg={2}>
          <div className="dropdown-label">Status</div>
          <Form.Select
            name="status"
            value={localFilters.status}
            onChange={(e) => {
              const value = e.target.value;

              setLocalFilters((prev) => ({
                ...prev,
                status: value,
              }));

              onFilterChange("status", value);
            }}
          >
            <option value="">Select Status</option>
            <option value="new">new</option>
            <option value="process">process</option>
            <option value="paid">paid</option>
          </Form.Select>
        </Form.Group>
        <Col className="d-flex justify-content-end align-items-center">
          <Button
            variant="primary"
            className="me-2"
            onClick={onFind}
            ref={findBtnRef}
            onKeyDown={(e) => handleKeyDown(e, resetBtnRef, onFind)}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Finding...
              </>
            ) : (
              "Find"
            )}
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              onReset();
              setLocalFilters({
                vendor_id: "",
                vendor_name: "",
                date: "",
                to_date: "",
              });
              setShowDropdown({ vendor_name: false });
            }}
            ref={resetBtnRef}
            onKeyDown={(e) => handleKeyDown(e, null, onReset)}
          >
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default PaymentFilter;
